import React from 'react';
import { AnnualPlanPage } from '../../pages/AnnualPlanPage';
import { useAuth } from '../../hooks/useAuth';
import { useAthleteContext } from '../../context/AthleteContext';
import { useTranslation } from 'react-i18next';

/** ATP — mobile shell around Ai-Tempo wizard (AnnualPlanPage). */
export function MobileAtpPage() {
  const auth = useAuth();
  const { effectiveUserId, coachMenuLocked } = useAthleteContext();
  const { t } = useTranslation();

  if (coachMenuLocked) {
    return <div className="mobile-empty-box">{t('coach.addAthleteFirst')}</div>;
  }

  return (
    <div className="mobile-screen mobile-screen--atp">
      <AnnualPlanPage user={auth.user} effectiveUserId={effectiveUserId} layout="mobile" />
    </div>
  );
}
